<template>
  <div>
    <div class="warp">
      <div class="title">
        <p>标题：{{ info.title }}</p>
        <p>
          <span>
            版本号：{{ info.version }}
          </span>
          <span>
            创建时间：{{ info.created_at }}
          </span>
        </p>
      </div>
      <div class="line"></div>
      <p class="content">{{ info.content }}</p>


    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      info: {}
    }
  },
  created() {
    this.info = JSON.parse(localStorage.getItem('noticeInfo'));
    console.log(this.info);
  },
  computed: {
  },
  methods: {
  },
}
</script>
<style lang="less" scoped>
.warp {
  width: 995px;
  height: 1728px;
  // background: #FEFEFE;
  box-shadow: 0px 0px 13px 2px rgba(68, 208, 201, 0.35);
  border-radius: 10px;
  margin-left: 65px;
  padding: 70px 49px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  font-size: 36px;
  color: #313131;

  p:nth-child(2) {
    margin-top: 56px;

    span:nth-child(2) {
      float: right;
    }
  }
}

.line {
  width: 899px;
  height: 4px;
  background: #3E7EFF;
  margin: 40px 0;
}

.content {
  font-family: Source Han Sans CN;
  font-weight: 400;
  font-size: 30px;
  color: #535353;
  white-space: pre-wrap
}
</style>
